import { changeCustomerShipToSelectorStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerShipToSelector";
import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(changeCustomerShipToSelectorStyles, {
    shipToSelectorDynamicDropdown: {
        cssOverrides: {
            dropdownWrapper: css`
                @media (max-width: 1199px) and (min-width: 280px) {
                    ul {
                        max-height: 158px;
                    }
                }
                span[data-test-selector^="changeCustomerShipToSelector-selectedText"] {
                    width: 94%;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    width: 90%;
                                `,
                                css`
                                    width: 95%;
                                `,
                                css`
                                    width: 92%;
                                `,
                            ],
                            "min",
                        )}
                }
            `,
        },
    },
});
